import React from "react";

const Schedule = (props) => {
  return (
    <div className="article-container" id="schedule-container">
      <h2>Schedule</h2>
      <div>
        <h3>Fri, 1 December, 2023</h3>
        <div className="titleslot">
          Binary Blast <br /> ALGORAVE @ hitness.club
        </div>
        <div>
          We are happy to have another Algorave event in Leipzig finally.{" "}
          <strong>On December 1, 2023 from 18:00 until midnite</strong>, we have
          a number of great artists from the local as well as the international
          livecoding community coming to perform at Hitness Club. Click the
          bubbles to learn more:
        </div>
        <div className="times">18:30-23:45 (GMT+1)</div>
        <div className="timetable">
          <div className="times">18.35 (GMT+1)</div>
          <div className="artistslot" onClick={() => props.setModal("staxl")}>
            Staxl
            <br />
            [.de]
          </div>

          <div className="times">19.10 (GMT+1)</div>
          <div className="artistslot" onClick={() => props.setModal("loopier")}>
            Loopier + blapunk
            <br />
            [.esp] + [.de]
          </div>

          <div className="times">19.45 (GMT+1)</div>
          <div className="artistslot" onClick={() => props.setModal("linasol")}>
            Linalab + alsolquema
            <br />
            [.esp] + [.arg]
          </div>

          <div className="times">20.20 (GMT+1)</div>
          <div
            className="artistslot"
            onClick={() => props.setModal("nervousdata")}
          >
            nervousdata
            <br />
            [.de]
          </div>

          <div className="times">20.55 (GMT+1)</div>
          <div
            className="artistslot"
            onClick={() => props.setModal("traumazone")}
          >
            TraumaZone
            <br />
            [.de]
          </div>

          <div className="times">21.30 (GMT+1)</div>
          <div
            className="artistslot"
            onClick={() => props.setModal("mrreason")}
          >
            MrReason
            <br />
            [.de]
          </div>

          <div className="times">22.05 (GMT+1)</div>
          <div className="artistslot" onClick={() => props.setModal("tmo")}>
            _t.mo
            <br />
            [.nl]
          </div>

          <div className="times">22.40 (GMT+1)</div>
          <div
            className="artistslot"
            onClick={() => props.setModal("parkellipsen")}
          >
            parkellipsen + z0rg
            <br />
            [.de] + [.fr]
          </div>

          <div className="times">23.15 (GMT+1)</div>
          <div
            className="artistslot"
            onClick={() => props.setModal("pondskater")}
          >
            Pondskater
            <br />
            [.de]
          </div>
        </div>
        <h3>Sat, 2 December, 2023</h3>
        <br />
        <div className="titleslot">
          Binary Blast <br /> Workshops & hackathon @ hitness.club
        </div>
        <div>
          To get you deeper into the world of livecoding,{" "}
          <strong>on December 2, 2023 from 11:00 until 18:00</strong> there'll
          be these three workshops and presentations. We'd be delighted to see
          you there!
          <br />
          All workshops are for free. (You can donate some money, if you like,
          but it's optional.)
          <br />
          Bringing your laptop is encouraged, so you can try things out for
          yourself.
        </div>
        <div className="times">11:00 (GMT+1)</div>
        <div className="genericslot">Doors opening at Hitness Club</div>
        <div className="times">11:30-12:00 (GMT+1)</div>
        <div className="genericslot">Welcome and introducing ourselves</div>
        <div className="times">12:00-13:00 (GMT+1)</div>
        <div
          className="eventslot"
          onClick={() => props.setModal("computerpoetry")}
        >
          computer-aided poetry ¦¦ show-and-tell by nervousdata
        </div>
        <div className="times">13:00-13:30 (GMT+1)</div>
        <div
          className="eventslot"
          onClick={() => props.setModal("databending")}
        >
          Databending/Datamoshing ¦¦ a quick introduction by Staxl
        </div>
        <div className="times">13:30-14:00 (GMT+1)</div>
        <div className="genericslot">Lunch break</div>
        <div className="times">14:00-15:00 (GMT+1)</div>
        <div className="eventslot" onClick={() => props.setModal("megra")}>
          Mégra ¦¦ presentation/show-and-tell by parkellipsen
        </div>
        <div className="times">15:00-18:00 (GMT+1)</div>
        <div className="eventslot" onClick={() => props.setModal("hackathon")}>
          Hackathon / Study Groups
        </div>
      </div>
    </div>
  );
};
export default Schedule;
